import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import Sidebar from '@components/Layout/Sidebar/Index.jsx';
import LogoutDropdown from "@components/Modals/Shared/LogoutDropdown/Index"

const Layout = () => {

  return (
    <div>
      <header>
        <div className="container">
          <div className="ttl">
            <h2 className='p-2'>Sistema de Gestão e Serviços para Governança e Integridade</h2>
          </div>

          <div className="rt">
            <div className="container-fluid">
              <div className="row">
                {/* logo */}
                <div className="col-12 col-md-4">
                  <Link to="/" className="logo">
                    <img
                      src="/senac.webp"
                      alt="Senac"
                      width="70"
                      height="50"
                    />
                  </Link>
                </div>

                {/* -------- dropdown Antd -------- */}
                <div className="col-12 col-md-8 d-flex justify-content-end align-items-center">
                  <LogoutDropdown />
                </div>
                {/* -------------------------------- */}
              </div>
            </div>
          </div>
        </div>
      </header>

      <div id="wrapcontent">
        <div className="container">
          <Sidebar />

          <section className="content">
            <article className="miolo">
              <div className="container-fluid">
                <Outlet />
              </div>
            </article>
          </section>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Layout);
